export default __webpack_public_path__ + "media/images/spinningwheel/sw-slot-border-8921994ed5d768d4669b993152d5155c.png";